import {
  actionLoading,
  actionSuccess,
  actionErrored,
  actionReset,
} from 'api/helpers';
import { unAuthRequest, authRequest } from 'api/helpers';
import URL, { getDynamicEndpoint } from 'api/endpoints';

// Fetch collection  seeds
export const FETCH_COLLECTION_SEEDS = 'FETCH_COLLECTION_SEEDS';

export const fetchCollectionSeedsLoading = actionLoading(
  FETCH_COLLECTION_SEEDS
);
export const fetchCollectionSeedsSuccess = actionSuccess(
  FETCH_COLLECTION_SEEDS
);
export const fetchCollectionSeedsErrored = actionErrored(
  FETCH_COLLECTION_SEEDS
);

export const fetchCollectionSeedsReset = actionReset(FETCH_COLLECTION_SEEDS);

export const fetchCollectionSeeds = (name) => {
  return (dispatch) =>
    authRequest.get(
      dispatch,
      getDynamicEndpoint(name).collection_seeds,
      fetchCollectionSeedsLoading,
      fetchCollectionSeedsSuccess,
      fetchCollectionSeedsErrored
    );
};

// REFETCH Collection seeds
export const REFETCH_COLLECTION_SEEDS = 'REFETCH_COLLECTION_SEEDS';

export const refetchCollectionSeedsLoading = actionLoading(
  REFETCH_COLLECTION_SEEDS
);
export const refetchCollectionSeedsSuccess = actionSuccess(
  REFETCH_COLLECTION_SEEDS
);
export const refetchCollectionSeedsErrored = actionErrored(
  REFETCH_COLLECTION_SEEDS
);

export const refetchCollectionSeedsReset = actionReset(
  REFETCH_COLLECTION_SEEDS
);

export const refetchCollectionSeeds = (name) => {
  return (dispatch) =>
    authRequest.get(
      dispatch,
      getDynamicEndpoint(name).collection_seeds,
      refetchCollectionSeedsLoading,
      refetchCollectionSeedsSuccess,
      refetchCollectionSeedsErrored
    );
};

// Create new collection
export const CREATE_NEW_SEED = 'CREATE_NEW_SEED';

export const createNewSeedLoading = actionLoading(CREATE_NEW_SEED);
export const createNewSeedSuccess = actionSuccess(CREATE_NEW_SEED);
export const createNewSeedErrored = actionErrored(CREATE_NEW_SEED);
export const createNewSeedReset = actionReset(CREATE_NEW_SEED);

export const createNewSeed = (collectionName, data) => {
  return (dispatch) =>
    authRequest.post(
      dispatch,
      data,
      getDynamicEndpoint(collectionName).add_collection_seed,
      createNewSeedLoading,
      createNewSeedSuccess,
      createNewSeedErrored
    );
};

export const resetCreateNewSeedState = () => {
  return function (dispatch) {
    dispatch(createNewSeedReset());
  };
};
